import { IUiIcon } from '../../../types/ui'

export const IconUploadCloud = (
	{
		size = 24,
		imgSize = 24,
		fill = 'none',
		stroke = 'currentColor'
	}: IUiIcon
) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg"
		     width={`${size}px`}
		     height={`${size}px`}
		     viewBox={`0 0 ${imgSize} ${imgSize}`}
		     fill={fill}
		     stroke={stroke}
		     strokeWidth="2"
		     strokeLinecap="round"
		     strokeLinejoin="round"
		     className="feather-upload-cloud"
		>
			<polyline points="16 16 12 12 8 16"></polyline>
			<line x1="12" y1="12" x2="12" y2="21"></line>
			<path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path>
			<polyline points="16 16 12 12 8 16"></polyline>
		</svg>
	)
}